import React from 'react';
import useCollapse from 'react-collapsed';
import {CSVLink, CSVDownload} from 'react-csv';
import {Button} from 'react-bootstrap';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import {Doughnut} from 'react-chartjs-2';
import faker from 'faker';

ChartJS.register(
  ArcElement,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

export default function ChartPieCollapsed(props) {
  const {getCollapseProps, getToggleProps, isExpanded} = useCollapse({
    defaultExpanded: true
  });

  let options1 = []; //Array of object
  let month_title = []; //Array of string

  props.chartdata.forEach((e) => {
    if (!month_title.includes(e.MONTH_YEAR_NAME)) {
      month_title = [...month_title, e.MONTH_YEAR_NAME];
      options1 = [
        ...options1,
        {
          responsive: true,
          plugins: {
            legend: {
              display: false
            },
            title: {
              display: true,
              text: e.MONTH_YEAR_NAME
            },
          }
        }
      ];
    }
  });

  const backgroundColor = [
    'rgba(255, 99, 132, 0.5)',
    'rgba(54, 162, 235, 0.5)',
    'rgba(255, 206, 86, 0.5)',
    'rgba(75, 192, 192, 0.5)',
    'rgba(153, 102, 255, 0.5)',
    'rgba(255, 159, 64, 0.5)'
  ]

  const percentage = (a , b) =>{
    return Math.round((a / b) * 100)
  }

  const formatPie = (datas) => {
    console.log(datas);
    const total1 = datas.reduce((prev, curr) => {
      return prev + curr.AMOUNT;
    }, 0);
    return {
      labels: datas.reduce((prev, curr) => {
        return [...prev, curr.TITLE + " : " + percentage(curr.AMOUNT,total1) + "%"];
      }, []),
      datasets: [
        {
          label: 'Redeem ',
          id: Math.random(),
          data: datas.reduce((prev, curr) => {
            return [...prev, curr.AMOUNT];
          }, []),
          backgroundColor: [
            'rgba(255, 99, 132, 0.5)',
            'rgba(54, 162, 235, 0.5)',
            'rgba(255, 206, 86, 0.5)',
            'rgba(75, 192, 192, 0.5)',
            'rgba(153, 102, 255, 0.5)',
            'rgba(255, 159, 64, 0.5)'
          ],
          borderColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)',
            'rgba(255, 159, 64, 1)'
          ],
          borderWidth: 1,
        }
      ]
    };
  };

  return (
    <div className="card card-success" id="card1">
      <div className="card-header">
        <h3 className="card-title">{props.chartname}</h3>
        <div className="card-tools">
          {/* <button
            type="button"
            className="btn btn-tool"
            data-card-widget="collapse"
            {...getToggleProps()}
          >
            <i className={isExpanded ? 'fas fa-minus' : 'fas fa-plus'}></i>
          </button> */}
        </div>
      </div>
      <div className="card-body" {...getCollapseProps()}>
        <div className='row'>
        {
          props.chartdata
          .filter((e) => (e.MONTH_YEAR_NAME === month_title[0]))
          .map((e, i) => (
            <div class="col-sm-3 col-md-3"><div style={{
              display: 'flex',
              fontSize: 12,
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: backgroundColor[i]
            }}>{e.TITLE}</div></div>
          ))
        }
        </div>
        <div className="chart">
          <div className="row">
            {month_title.map((e, i) => (
              <div className="col-12 col-sm-6 col-md-6" key={i}>
                <Doughnut
                  datasetIdKey='id'
                  key={Math.random()}
                  options={options1[i]}
                  data={formatPie(
                    props.chartdata.filter((e) => {
                      return e.MONTH_YEAR_NAME === month_title[i];
                    })
                  )}
                  // data={formatPie(props.chartdata)}
                  style={{
                    minHeight: 220,
                    height: 220,
                    maxHeight: 220,
                    maxWidth: '100%',
                    display: 'block'
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="card-footer">
        <CSVLink filename={props.chartname} className="btn btn-primary" data={props.csvdata}>
          CSV
        </CSVLink>
        <Button variant="success" className='ml-2' onClick={()=>{props.export(props.csvdata, props.chartname)}}>Excel</Button>
      </div>
    </div>
  );
}
